import { createSlice } from '@reduxjs/toolkit';
import { createAppAsyncThunk } from '../../createAppAsyncThunk';
import { API_POST } from '../../../services';
import { ProductSyncDetails } from '../../../models/ProductSyncDetailsModel';
import type { RootState } from '../../store';
import { env } from '../../../env';
import { ENDPOINTS } from '../../../constants/endPoints';
import { RADRequest } from '../../../models/common/RADRequest';

interface ProductSyncState {
  data: ProductSyncDetails | null;
  isLoading: boolean;
}

const initialState: ProductSyncState = {
  data: null,
  isLoading: false,
};

// Async thunk to fetch Product Sync data
export const fetchProductSync = createAppAsyncThunk(
  'ecommerce/fetchProductSync',
  async (payload: RADRequest) => {
    const requestBody = {
      StoreNumber: payload.storeNumber,
      IsMultiStoreMode: payload.isMultiStoreMode,
    };

    const response = await API_POST(
      `${env.RAD_APP_API_URL}${ENDPOINTS.GET_PRODUCT_SYNC}`,
      requestBody,
    );
    return response as ProductSyncDetails;
  },
);

// Product Sync slice
const productSyncSlice = createSlice({
  name: 'productSync',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchProductSync.pending, state => {
        state.isLoading = true;
      })
      .addCase(fetchProductSync.fulfilled, (state, action) => {
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchProductSync.rejected, state => {
        state.data = null;
        state.isLoading = false;
      });
  },
});

// Selectors
export const selectProductSync = (state: RootState) => state.productSync.data;
export const selectProductSyncLoading = (state: RootState) => state.productSync.isLoading;

export default productSyncSlice.reducer;
